<template>
    <div>
      <logonav v-if="brand == 'liteon'" />
      <navigation v-if="brand != 'liteon'"/>
      <div id="chapternav" class="chapternav fixed-top" data-analytics-region="family browser">
          <div class="chapternav-wrapper">
            <ul class="chapternav-items">
              <li class="chapternav-item">
                <router-link class="chapternav-link" to="/billing_lists">
                  <div class="chapternav-icon"><img :src="'img/' + brand + '/chapternav-icon/icon-billing.png'" alt="" /></div>
                  <span class="chapternav-label">停車帳務</span> 
                </router-link>
              </li>
              <li class="chapternav-item">
                <router-link class="chapternav-link" to="/settings_plate">
                  <div class="chapternav-icon"><img :src="'img/' + brand + '/chapternav-icon/icon-plate.png'" alt="" /></div>
                  <span class="chapternav-label">車牌設定</span>
                </router-link>
              </li>
              <li class="chapternav-item">
                <router-link class="chapternav-link" to="/settings_invoice">
                  <div class="chapternav-icon"><img :src="'img/' + brand + '/chapternav-icon/icon-invoice.png'" alt="" /></div>
                  <span class="chapternav-label">發票設定</span> 
                </router-link>
              </li>
              <!--
              <li class="chapternav-item">
                <router-link class="chapternav-link" to="/settings_payment">
                  <div class="chapternav-icon"><img src="img/parkit/chapternav-icon/icon-payment.png" alt="" /></div>
                  <span class="chapternav-label">支付設定</span> 
                </router-link>
              </li>
              -->
              <li class="chapternav-item">
                <router-link class="chapternav-link" to="/settings_profile">
                  <div class="chapternav-icon"><img :src="'img/' + brand + '/chapternav-icon/icon-profile.png'" alt="" /></div>
                  <span class="chapternav-label">個人設定</span>
                </router-link>
              </li>
              <li class="chapternav-item" v-if="brand != 'liteon'">
                <router-link class="chapternav-link" to="/member_center">
                  <div class="chapternav-icon"><img :src="'img/'+ brand +'/chapternav-icon/icon-logout.png'" alt="" /></div>
                  <span class="chapternav-label">會員登出</span> 
                </router-link>
              </li> 
            </ul>
          </div>
      </div><!-- chapternav ends -->
    </div>
</template>

<script>
export default {
  name: 'ChapterNav',
  props: {
  },
  data() {
    return {
      brand: process.env.VUE_APP_BRAND
    }
  },
  mounted() {
    var self = this
  },
  methods: {
  }
}
</script>